import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * A route that needs an ACCOUNT and nothing else.
 *
 * `PrivateRoute` is the contractor gate: it asks whether the user has a
 * subscription or preview access, and bounces everyone else to a waitlist
 * about becoming a contractor. A homeowner who signed up from a shared design
 * has neither and wants neither — the only question their pages ask is "is
 * this a real account rather than a share-link visitor", which is the same
 * test `isAccount()` makes in the Firestore rules.
 *
 * `user` is already the app's ACCOUNT user (App.js nulls an anonymous one), so
 * a share-link visitor reads as signed out here and is sent to log in.
 */
function AccountRoute({ children, user, isAuthenticatingFromIOS }) {
  if (isAuthenticatingFromIOS) return null;
  if (!user) return <Navigate to="/login" />;
  return children;
}

export default AccountRoute;
